export default __webpack_public_path__ + "6ace2406b97ff60e8aae5090c14dfb03.png";